<template>
  <el-card style="height:100%;">
    <div style="padding: 8px;overflow-y:scroll ;border-top:1px solid gray;border-bottom:1px solid gray;height:100%;">
      <el-tree :data="data1" node-key="id" default-expand-all :expand-on-click-node="false" highlight-current>
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <span>{{ node.label }}</span>
          </span>
          <span>
            <el-tag type="" size="medium" style="min-width:130px;" @click="handleNodeClick(data)">
              采购价：{{getBOMInventPurchPrice(data,6)}}
            </el-tag>
            <el-tag type="danger" size="medium" style="min-width:130px;padding-right: 0px;" class="ml-2">
              实际计算价：<el-input clearable autosize style="width: 150px;" type="number" v-model="data.actal_purch_price"></el-input>
            </el-tag>
          </span>
        </span>
      </el-tree>
    </div>
    <div style="float:right">
      <el-button type="success" class="m-2" @click="SaveData"><i class="iconfont icon-save"></i>&nbsp;&nbsp;{{$t("common.save")}}
      </el-button>
    </div>
    <div>
      <BaseModal ref="invent_price_modal" :title="invent_price_modal_title" :width="'30%'" @saveData="SaveData" :modal="false">
        <template #modal_content>
          <el-form ref="dataForm" label-width="150px" class="demo-dataForm" style="height: 200px">
            <el-col :span="24">
              <el-form-item label="销售公司">
                {{InventPriceModel.dataAreaId}}
              </el-form-item>
              <el-form-item label="物料名称">
                {{InventPriceModel.NameAlias}}
              </el-form-item>
              <el-form-item label="报价计算成本价格">
                <el-input type="number" v-model="InventPriceModel.price" clearable></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </template>
      </BaseModal>
    </div>
  </el-card>
</template>

<script>
import BaseModal from "../components/modals/baseModal";
export default {
  props: ["data1", "dataAreaId"],
  components: {
    BaseModal
  },
  data() {
    return {
      InventPriceModel: {
        dataAreaId: "",
        ItemId: "",
        NameAlias: "",
        price: 0
      },
      invent_price_modal_title: "调整报价计算成本价格",
      cur_node: {}
    }
  },
  created() {
  },
  methods: {
    //#region 整理显示数据
    getFullNum(num) {
      //处理非数字
      if (isNaN(num)) { return num }

      //处理不需要转换的数字
      var str = '' + num;
      if (!/e/i.test(str)) { return num; }

      return (num).toFixed(18).replace(/\.?0+$/, "");
    },
    getBOMInventPurchPrice(data, spc) {
      if (spc)
        return _.round(data.purch_price, spc);
      else
        return _.round(data.purch_price, 6);
    },

    //#endregion
    //#region node点击
    handleNodeClick(data) {

      this.cur_node = data;
      this.InventPriceModel.ItemId = data.ItemId;
      this.InventPriceModel.NameAlias = data.label;
      this.InventPriceModel.price = data.purch_price;
      this.InventPriceModel.dataAreaId = this.dataAreaId;
      this.$refs.invent_price_modal.show()
    },
    async SaveData() {
      let dt = _.filter(this.data1, (t) => { return parseFloat(t.actal_purch_price) > 0 });
      await this.$emit("saveQuoteInventPrice", dt);
    },
    //#endregion

  },
}
</script>
<style >
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 0px;
}
.bom
  .el-tree--highlight-current
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #ffa5a5;
}
.hb_table_routecost_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 100rem;
}
.bom .el-card__body,
.el-main {
  padding: 0px;
}
</style>

